export default __webpack_public_path__ + "static/media/hht1_ep2_minisitcom_04.d9c213b1.png";